import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { validation } from 'site-modules/shared/components/form-validation/validation';
import { StyledZipInput } from 'site-modules/shared/components/styled-zip-input/styled-zip-input';
import { ModelsList } from 'site-modules/incentives/components/models-list/models-list';
import { ModelsGrid } from 'site-modules/incentives/components/models-grid/models-grid';

const LIST_MODE = 'list';
const GRID_MODE = 'grid';
const MODELS_COMPONENT = { [LIST_MODE]: ModelsList, [GRID_MODE]: ModelsGrid };
const MODE_BUTTONS = [
  { label: 'Thumbnail View', mode: GRID_MODE },
  { label: 'List View', mode: LIST_MODE },
];

export function IncentivesByModel({ models, makeName }) {
  const [viewMode, setViewMode] = useState(GRID_MODE);
  const ModelsView = MODELS_COMPONENT[viewMode];

  function setMode({
    target: {
      dataset: { mode },
    },
  }) {
    setViewMode(mode);
  }

  return (
    <div className="incentives-by-model px-0">
      {!!models.length && (
        <div className="mb-1_5 d-flex justify-content-between align-items-center">
          <div>
            {MODE_BUTTONS.map(({ label, mode }, index) => (
              <Fragment key={mode}>
                {!!index && <span className="mx-0_5 text-gray-darker">|</span>}
                <Button
                  color="link"
                  className={classnames('switch-btn p-0 text-capitalize', {
                    'text-primary-darker': viewMode === mode,
                    'fw-normal': viewMode !== mode,
                  })}
                  onClick={setMode}
                  data-mode={mode}
                  data-tracking-id="im_tool_select"
                  data-no-refresh
                >
                  {label}
                </Button>
              </Fragment>
            ))}
          </div>
          <StyledZipInput
            inputClasses="search-by-zip-input size-16"
            onValidate={validation.validateZip}
            size="lg"
            getTracking={{ 'data-tracking-id': 'provide_zip_code' }}
          />
        </div>
      )}
      <ModelsView models={models} makeName={makeName} />
    </div>
  );
}

IncentivesByModel.propTypes = {
  makeName: PropTypes.string.isRequired,
  models: VehicleEntities.ModelYearsByMakeId.isRequired,
};
